import { toast } from "sonner";
import {
  CheckCircle2,
  XCircle,
  Info,
  AlertTriangle,
} from "lucide-react";

// Theme-matched toast styling (mirrors App.jsx ConfigProvider palette).
const PALETTE = {
  success: "#4A7C59",
  error: "#B5511C",
  info: "#4A6FA5",
  warning: "#C4882A",
};

const ICON_PROPS = { size: 20, strokeWidth: 2.2 };

const ICONS = {
  success: <CheckCircle2 {...ICON_PROPS} color={PALETTE.success} />,
  error: <XCircle {...ICON_PROPS} color={PALETTE.error} />,
  info: <Info {...ICON_PROPS} color={PALETTE.info} />,
  warning: <AlertTriangle {...ICON_PROPS} color={PALETTE.warning} />,
};

const baseStyle = (type) => ({
  background: "#FDFAF4",
  color: "#3D1A07",
  border: "1px solid #E0CEAF",
  borderLeft: `4px solid ${PALETTE[type]}`,
  borderRadius: 8,
  fontFamily: "'Inter', sans-serif",
  boxShadow: "0 6px 24px rgba(61, 26, 7, 0.12)",
});

function show(type, message, options = {}) {
  if (!message) return;
  toast.dismiss();
  const { description, duration } = options;
  toast[type](message, {
    icon: ICONS[type],
    description,
    duration,
    style: baseStyle(type),
    className: `sulsa-toast sulsa-toast-${type}`,
  });
}

export default class Notification {
  static success(message, options) {
    show("success", message, options);
  }

  static error(message, options) {
    show("error", message, options);
  }

  static info(message, options) {
    show("info", message, options);
  }

  static warning(message, options) {
    show("warning", message, options);
  }

  static clearAll() {
    toast.dismiss();
  }
}
